import { useDemo } from "../zustand/DemoZustand";
import { Tagesordnungsliste } from "./Sitzungsteile";
import { Fragezeichen, Haken, Kreuz } from "./Symbole";
import { meineTeilnahme, teilnahmeZaehlung } from "../hilfen/auswertung";
import { kurzesDatum, tageBis, uhrzeit, wochentag } from "../hilfen/datum";

/*
  Die linke Spalte — sie steht still, während rechts gearbeitet wird.

  Früher wechselte diese Spalte ihren Inhalt: mal Tagesordnung, mal Chat. Das
  war der Grund, warum man sich beim Vorbereiten verlaufen konnte. Jetzt steht
  hier immer dasselbe, und nur die rechte Seite ändert sich. Wer weiß, wo er
  ist, klickt sich nicht in eine Sackgasse.

  Aufbau von oben nach unten, in der Reihenfolge, in der man es braucht:
  welche Sitzung, welche Punkte, komme ich hin.
*/

export default function Tagesordnungsspalte({ topId, oeffne }) {
  const { stammdaten } = useDemo();
  const ausschuss = stammdaten.sitzungen[stammdaten.ausschussId];
  const gremium = stammdaten.gremien[ausschuss.gremiumId];

  return (
    <>
      <div className="spaltenkopf">
        <span className="spaltenkopf__titel">Tagesordnung</span>
        <span className="klein leise">{tageBis(ausschuss.beginn)} Tage</span>
      </div>

      <p className="tospalte__gremium">{gremium.name}</p>

      <Tagesordnungsliste oeffne={oeffne} gewaehltId={topId} />

      <Sitzungsfuss />
    </>
  );
}

/*
  Der Fuß der Spalte: die beiden Termine und die eigene Rückmeldung.

  Die Frage „Kommst du?“ gilt der Fraktionssitzung, nicht der Ausschusssitzung.
  Zur Ausschusssitzung erscheint man als gewähltes Mitglied ohnehin oder lässt
  sich vertreten — das ist keine Sache, die man in einer App zusagt. Die
  Fraktionssitzung dagegen ist eine interne Verabredung, und dort ist die
  Rückmeldung das, was die Geschäftsführung wirklich braucht.
*/
function Sitzungsfuss() {
  const { stammdaten, zustand, ich, aktionen } = useDemo();
  const ausschuss = stammdaten.sitzungen[stammdaten.ausschussId];
  const fraktion = stammdaten.sitzungen["s-fraktion"];

  const meine = meineTeilnahme(zustand, ich.id, fraktion.id);
  const zaehlung = teilnahmeZaehlung(zustand, fraktion.id);

  return (
    <div className="tospalte__fuss">
      <Termin
        name="Fraktionssitzung"
        sitzung={fraktion}
        hinweis="bereitet die Ausschusssitzung vor"
      />
      <Termin name="Ausschusssitzung" sitzung={ausschuss} />

      <p className="tospalte__frage">Kommst du zur Fraktionssitzung?</p>

      <div className="wahl wahl--eng">
        {[
          ["ja", "Ja", Haken],
          ["nein", "Nein", Kreuz],
          ["unklar", "Unklar", Fragezeichen],
        ].map(([wert, beschriftung, Symbol]) => (
          <button
            key={wert}
            className="wahl__knopf"
            aria-pressed={meine === wert}
            onClick={() => aktionen.setzeTeilnahme(fraktion.id, wert)}
          >
            <Symbol groesse={16} />
            {beschriftung}
          </button>
        ))}
      </div>

      <p className="klein leise" style={{ marginTop: "var(--luft-2)" }}>
        {zaehlung.ja} zugesagt, {zaehlung.nein} abgesagt, {zaehlung.unklar} unklar,{" "}
        {zaehlung.offen} ohne Rückmeldung.
      </p>
    </div>
  );
}

function Termin({ name, sitzung, hinweis }) {
  return (
    <div className="tospalte__termin">
      <span className="tospalte__tag">
        {wochentag(sitzung.beginn).slice(0, 2)}. {kurzesDatum(sitzung.beginn)}
      </span>
      <span>
        <strong>{name}</strong>, {uhrzeit(sitzung.beginn)}
        <br />
        <span className="klein leise">{hinweis || sitzung.ort}</span>
      </span>
    </div>
  );
}
